import * as React from 'react'

export const IconSuccessFilled: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: Omit<
    React.SVGProps<SVGSVGElement>,
    'dominantBaseline' | 'textAnchor' | 'clipRule' | 'fillRule' | 'strokeLinecap' | 'strokeLinejoin'
  >
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M17.298 8.293a1 1 0 0 0-1.418-.003L10 14.17l-2.885-2.876a.998.998 0 0 0-1.41 1.412l3.588 3.587a1 1 0 0 0 1.414 0l6.588-6.588a1 1 0 0 0 .002-1.412M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2"
      />
    </g>
    <path
      fill="#fff"
      d="M17.374 8.704a.94.94 0 0 0-1.354-.002l-5.405 5.594-2.64-2.725a.937.937 0 0 0-1.346 1.303l3.267 3.382a1 1 0 0 0 1.439 0l6.037-6.249a.94.94 0 0 0 .002-1.303"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
